import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges } from '@angular/core';
/**
  * Rxjs imports.
  */
import { Subscription } from 'rxjs';

/**
  * Import Service
*/
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { PostApiService } from './../../dataservices/post-api.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
/**
* Modal imports.
*/
import { CommunityMember } from '../../onboarding/interface/global.model';
import { AcceptRejectJoinRequestCommunityResponse } from '../../onboarding/interface/apiResponse.model';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
/**
* Constant imports.
*/
import { NUMBERS, COMMUNITY_JOIN_ACTION, STATUS_CODE, SCREEN_NAME, PRODUCT_TYPE_CONSTANT } from '../../../app/constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';

@Component({
  selector: 'app-community-join-requests',
  templateUrl: './community-join-requests.component.html',
  styleUrls: ['./community-join-requests.component.scss']
})
export class CommunityJoinRequestsComponent implements OnInit, OnChanges, OnDestroy {
  @Output() reloadJoinRequetApi = new EventEmitter();
  /**
   * Input Variable to get Joining Requests Data from API
   * Input Variable to get Community Id
   * Input Variable to get Join Request API OffSet
   * Input Variable to get Loader State
   * Input Variable to get community Id
   */
  @Input() joiningRequestsData: CommunityMember[] = [];
  @Input() communityId: string;
  @Input() joinRequestOffSet: number;
  @Input() loaderState: boolean;
  @Input() callingFrom : string;
  @Input() communityDetailId : number;

  /**
   * Get numbers from constants
   * Set api loader finished state as false by default
   * Set default state for confirmation modal in case of ignore request
   * Set confirmation information
   * Set Join Request Object
   */
  public numbers = NUMBERS;
  public finished = false;
  public isConfirmModalShown = false;
  public confirmInfo = '';
  public joinReqObj: CommunityMember;
  /**
    * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * For using analytics interface
   */
  public analyticsAcceptData: AnalyticsInterface;
  /**
   * For storing value of connect data
   */
  public analyticsRejectData: AnalyticsInterface;
  /**
   * For value of community id
   */
  public community_Id: string;

  constructor(public mls: NewLanguageService,
              public masterService: MasterserviceService,
              public igs: ImageGroupService,
              public postService: PostApiService,
              public fcs: FunCollectionService
  ) { }

  /**
   * On Init
   */
  ngOnInit(): void {
    this.finished = this.loaderState;
    this.generateAnalyticsData();
    this.community_Id = this.communityId;
  }

  /**
   * On Changes
   */
  ngOnChanges(): void {
    this.finished = this.loaderState;
  }

  /**
   * On Scroll
   */
  onScroll(): void {
    if (this.joinRequestOffSet > NUMBERS.ONE) {
      this.finished = false;
      this.reloadJoinRequetApi.emit({ offSet: this.joinRequestOffSet });
    }

  }

  /**
   * Function to ignore join request
   */
  ignoreJoinRequest(reqObj: CommunityMember): void {
    this.joinReqObj = reqObj;
    this.isConfirmModalShown = true;
    const user_name = reqObj && reqObj['full_name'] ? reqObj['full_name'] : 'user';
    this.confirmInfo = this.fcs.replaceWithValue(this.mls.languageText.community.key99, user_name);
  }

  /**
   * Function to check confirmation modal state
   */
  resetConfirmModal(event): void {
    this.isConfirmModalShown = false;
    if (event) {
      this.ignoreJoinRequestAPI();
    }
  }

  /**
   * Function to Accept Join Request
   */
  acceptJoinRequest(reqObj: CommunityMember): void {
    const memberObj = {
      'members': [{
        'custom_id': reqObj['custom_id'],
        'action': NUMBERS.ONE.toString() // 0->reject,1->accept
      }
      ]
    };
    this.subscriptions.add(this.postService.acceptRejectJoinRequestFromCommunity(this.communityId, memberObj)
      .subscribe((res: AcceptRejectJoinRequestCommunityResponse) => {
        if (res.status === NUMBERS.ONE) {
          const user_name = (reqObj && reqObj['full_name']) ? reqObj['full_name'] : 'user';
          const message = this.fcs.replaceWithValue(this.mls.languageText.community.key100, user_name);
          this.fcs.showSuccess(message, this.mls.languageText.toster.key2);
          this.reloadJoinRequetApi.emit({ offSet: NUMBERS.ONE, action: COMMUNITY_JOIN_ACTION.ACCEPT });
        } else {
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }

  /**
   * Function to ignore Join Request
   */
  ignoreJoinRequestAPI(): void {
    const memberObj = {
      'members': [{
        'custom_id': this.joinReqObj['custom_id'],
        'action': NUMBERS.ZERO.toString() // 0->reject,1->accept
      }
      ]
    };
    this.subscriptions.add(this.postService.acceptRejectJoinRequestFromCommunity(this.communityId, memberObj)
      .subscribe((res: AcceptRejectJoinRequestCommunityResponse) => {
        if (res.status === NUMBERS.ONE) {
          const user_name = this.joinReqObj && this.joinReqObj['full_name'] ? this.joinReqObj['full_name'] : 'user';
          const message = this.fcs.replaceWithValue(this.mls.languageText.community.key101, user_name);
          this.fcs.showSuccess(message, this.mls.languageText.toster.key2);
          this.reloadJoinRequetApi.emit({offSet: NUMBERS.ONE, action: COMMUNITY_JOIN_ACTION.REJECT});
        } else {
          if(res.error.code === STATUS_CODE.ONE_THOUSAND_ONE) {
            this.reloadJoinRequetApi.emit({offSet: NUMBERS.ONE, action: COMMUNITY_JOIN_ACTION.REJECT});
          }
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }

  generateAnalyticsData(): void {
    const events = {
      'analyticsAcceptData': EVENT_NAME.COMMUNITY_REQUEST_ACCEPT_CLICK,
      'analyticsRejectData': EVENT_NAME.COMMUNITY_REQUEST_REJECT_CLICK,
    };
    // tslint:disable-next-line: forin
    for (const event in events) {
      this[event] = {
        'event_name': events[event],
        'product_type': PRODUCT_TYPE_CONSTANT.COMMUNITY,
        'product_type_id': this.communityDetailId,
        'screen_name': SCREEN_NAME.COMMUNITY_DETAILS,
      };
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

}
